import { mapTaskCategoryFromDto } from '../tasks/helpers'
import { IPackageDto, IProductDto } from './dtos'
import { IPackage, IProduct, ProductCategory } from './models'

export function mapProductCategoryFromDto(
	productCategory: 'CASE' | 'PORTRAIT' | 'LOCATION' | 'SHOP' | 'ENDUSERFEE'
): ProductCategory {
	switch (productCategory) {
		case 'CASE':
			return ProductCategory.Case

		case 'PORTRAIT':
			return ProductCategory.Portrait

		case 'LOCATION':
			return ProductCategory.Location

		case 'SHOP':
			return ProductCategory.Shop

		case 'ENDUSERFEE':
			return ProductCategory.EndUserFee

		default:
			return ProductCategory.None
	}
}

export function mapProductFromDto(dto: IProductDto): IProduct {
	const {
		id,
		name,
		imageSrc,
		imageThumbnailSrc,
		description,
		price,
		quantity,
		currency,
		unit,
		maxOrderAmount,
		maxKvmSize,
		tasks,
		showAlert,
		itemNumber,
		config,
		variant,
	} = dto

	return {
		_dto: dto,
		id,
		name,
		description,
		quantity,
		thumbnail: imageThumbnailSrc || imageSrc,
		price,
		currency,
		maxOrderAmount,
		maxKvmSize,
		tasks: tasks?.map(({ type }) => ({ type: mapTaskCategoryFromDto(type) })) || [],
		unit,
		showAlert,
		itemNumber,
		config,
		variant,
	}
}

export function mapPackageFromDto(dto: IPackageDto): IPackage {
	const {
		grouping,
		id,
		name,
		imageSrc,
		imageThumbnailSrc,
		description,
		price,
		currency,
		products,
		requiredProductOptions,
		itemNumber,
		config,
		packages,
	} = dto

	return {
		_dto: dto,
		id,
		thumbnail: imageThumbnailSrc?.includes('http') ? imageThumbnailSrc : imageSrc,
		name,
		description,
		totalPrice: price || 0,
		basePrice: price || 0,
		currency,
		type: grouping,
		products: products?.map(mapProductFromDto) || [],
		choices: requiredProductOptions?.map(option => ({
			minPrice: option.minPrice,
			group: option.groupName,
			products: option.products.map(mapProductFromDto),
			packages: option.packages?.map(mapPackageFromDto),
		})),
		packages: packages ? packages.map(mapPackageFromDto) : undefined,
		itemNumber,
		config,
	}
}
